export default {
    _form: null,
    _formContainer: null,
    _fibercheck : null,

    init() {
        this._fibercheck = document.querySelector('[data-fibercheck]');

        if(!(this._fibercheck)){
            return;
        }
/* valid postcode => open form,
    Invalid postcode => invalid msgbox, then open same form */

        this._fibercheck.addEventListener(('click'), (e) => {
            e.preventDefault();
            const xhr = new XMLHttpRequest();
            xhr.onload = () => {
                if (xhr.responseText) {
                    const result = JSON.parse(xhr.responseText);
                    if(result['status'] == true){
                        this._formContainer = document.getElementById('fiberInterestModal');
                        
                        const formIntro = this._formContainer.querySelector('.fiberInterest__form-intro');
                        let htmlsnippet = `<h2 class="header--accent">Altibox er i nærheten!</h2>
                        <p>Meld din interesse så får du en tilbakemelding om eventuell leveranse til din bolig.</p>` ;
                        formIntro.innerHTML = htmlsnippet;

                        this._formContainer.classList.add(this._formContainer.classList[0]+ "--active");
                        document.getElementById("fields-address").value = result['address'];
                        document.getElementById("fields-postcode").value = result['postcode'];
                        
                        const closeBtn  = document.getElementById('windowclose');
                        closeBtn.addEventListener('click',()=>{
                            this._formContainer.classList.remove(this._formContainer.classList[0]+ "--active");
                        })
                    }else{
                        let containerInvalid = document.getElementById('fiberInterestInvalid');
                        containerInvalid.classList.add(containerInvalid.classList[0]+ "--active");
                        const closeBtn  = document.getElementById('windowcloseInvalid');
                        closeBtn.addEventListener('click',()=>{
                            containerInvalid.classList.remove(containerInvalid.classList[0]+ "--active");
                        });
                        const formOpen = containerInvalid.querySelector('[data-interestform-open]');
                        formOpen.addEventListener('click',(e)=>{
                            e.preventDefault();
                            containerInvalid.classList.remove(containerInvalid.classList[0]+ "--active");
                            this._formContainer = document.getElementById('fiberInterestModal');
                            const formIntro = this._formContainer.querySelector('.fiberInterest__form-intro');
                            let htmlsnippet = `<h2 class="header--accent">Ikke helt enda</h2>
                            <p>Istad Fiber har ikke fibernett der du bor, men vi bygger kontinuerlig ut for å gi så mange som mulig tilgang til Norges råeste fiberbredbånd.
                  Registrer din interesse, og vi vil kontakte deg når vi vurderer utbygging.<br>` ;
                            formIntro.innerHTML = htmlsnippet;
                            this._formContainer.classList.add(this._formContainer.classList[0]+ "--active");
                            document.getElementById("fields-address").value = result['address'];
                            document.getElementById("fields-postcode").value = result['postcode'];
                        });
                    }
                } else {
                    console.error('ERROR: Could not GET response');
                }
            }
            const postnr  = document.getElementById("sjekkpostnummer").value ;
            const add  = document.getElementById("sjekkadresse").value ;
            const formCheck  = document.getElementById("fibercheck");
            var formData = new FormData(formCheck);
            xhr.open('post', '/actions/istad/istadfiber/areacheck');
            xhr.send(formData);
            const closeBtn  = document.getElementById('windowclose');
            closeBtn.addEventListener('click',()=>{
                this._formContainer = document.getElementById('fiberInterestModal');
                this._formContainer.classList.remove(this._formContainer.classList[0]+ "--active");
            })

        })
    }
}
